import React, { useState, useEffect } from "react";
import Sidenav from "../components/Sidenav";
import Toolbar from "@mui/material/Toolbar";
import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Barchart from "../charts/Barchart";
import CountUp from "react-countup";
import axios from "axios";
import { Stack } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import config from "../config/config";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const drawerWidth = 240;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function Home() {
  const [data, setData] = useState(null); // Store API response
  const token = localStorage.getItem("token")?.replace(/['"]/g, "");
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${config.baseUrl}/Report?user_id=${localStorage.getItem("user_id")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setData(response.data); // Save response data
      } else {
        console.error("Unexpected response:", response.status, response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", {
        message: error.message,
        response: error.response?.data || null,
      });
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Convert to seconds

        if (decodedToken.exp && decodedToken.exp > currentTime) {
          navigate("/");
        } else {
          localStorage.removeItem("token"); // Remove expired token
          navigate("/login"); // Redirect to login if expired
        }
      } catch (error) {
        console.error("Invalid token", error);
        localStorage.removeItem("token");
        navigate("/login"); // Redirect if the token is invalid
      }
    } else {
      navigate("/login"); // Redirect if no token exists
    }
    fetchData();
  }, [navigate]);

  const renderGridItems = () => {
    if (!data) return null;

    if (data.purchases !== undefined) {
      // Admin View
      return (
        <>
          <Grid item xs={12} sm={4}>
            <Item
              sx={{
                height: "120px",
                backgroundImage:
                  "linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%)",
                color: "#fff",
              }}
            >
              <h4 style={{ color: "#fff" }}>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <CurrencyRupeeIcon /> <CountUp delay={1} end={data.purchases} />
                </Stack>
              </h4>
              <p>Total Purchases</p>
            </Item>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Item
              sx={{
                height: "120px",
                backgroundImage:
                  "linear-gradient(to top, #ff0844 0%, #ffb199 100%)",
                color: "#fff",
              }}
            >
              <h4 style={{ color: "#fff" }}>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <CurrencyRupeeIcon /> <CountUp delay={1} end={data.earnings} />
                </Stack>
              </h4>
              <p>Total Earnings</p>
            </Item>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Item
              sx={{
                height: "120px",
                backgroundImage:
                  "linear-gradient(to top, #9be15d 0%, #00e3ae 100%)",
                color: "#fff",
              }}
            >
              <h4 style={{ color: "#fff" }}>
                <CountUp delay={1} end={data.new_customers} />
              </h4>
              <p>New Customers</p>
            </Item>
          </Grid>
        </>
      );
    } else {
      // User View
      return (
        <>
          <Grid item xs={12} sm={4}>
            <Item
              sx={{
                height: "120px",
                backgroundImage:
                  "linear-gradient(to top, #ff0844 0%, #ffb199 100%)",
                color: "#fff",
              }}
            >
              <h4 style={{ color: "#fff" }}>
                <CountUp delay={1} end={data.items_requested} />
              </h4>
              <p>Items Requested</p>
            </Item>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Item
              sx={{
                height: "120px",
                backgroundImage:
                  "linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%)",
                color: "#fff",
              }}
            >
              <h4 style={{ color: "#fff" }}>
                <CountUp delay={1} end={data.item_in_transit} />
              </h4>
              <p>Items In Transit</p>
            </Item>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Item
              sx={{
                height: "120px",
                backgroundImage:
                  "linear-gradient(to top, #9be15d 0%, #00e3ae 100%)",
                color: "#fff",
              }}
            >
              <h4 style={{ color: "#fff" }}>
                <CountUp delay={1} end={data.items_delivered} />
              </h4>
              <p>Items Delivered</p>
            </Item>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Item
              sx={{
                height: "120px",
                backgroundImage:
                  "linear-gradient(to top, #f7e2c5 0%, #f0ad4e 100%)",
                color: "#fff",
              }}
            >
              <h4 style={{ color: "#fff" }}>
                <CountUp delay={1} end={data.not_available} />
              </h4>
              <p>Not Available</p>
            </Item>
          </Grid>
        </>
      );
    }
  };

  return (
    <div>
      <Box />
      <Box sx={{ display: "flex" }}>
        <Sidenav />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              {renderGridItems()}
            </Grid>
            {localStorage.getItem("role") === "Admin" ? <Grid container sx={{ mt: 2 }} >
              <Grid item xs={12} sm={12}>
                <Item sx={{ height: "450px" }}>
                  <Barchart />
                </Item>
              </Grid>
            </Grid> : null}

          </Box>
        </Box>
      </Box>
    </div>
  );
}
